import React from 'react';
import ReduxToastr from 'react-redux-toastr';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from 'react-redux-toastr/lib/css/react-redux-toastr.min.css';

class Toaster extends React.Component {
  static propTypes = {};

  render() {
    return <ReduxToastr
      timeOut={5000}
      newestOnTop={false}
      preventDuplicates={true}
      position="top-right"
      transitionIn="fadeIn"
      transitionOut="fadeOut"
    />;
  }
}

export default withStyles(s)(Toaster);